import { render, staticRenderFns } from "./NotificationWidget.vue?vue&type=template&id=606dc733&scoped=true"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"
import style0 from "./NotificationWidget.vue?vue&type=style&index=0&id=606dc733&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dc733",
  null
  
)

export default component.exports